export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/ra.993f7955.svg","height":68,"width":140,"blurWidth":0,"blurHeight":0};